export type FaqCategory = "Pricing";

export const HIDDEN_FAQ_IDS_BY_CATEGORY: Record<string, Set<string>> = {
  Pricing: new Set([
    "1hfJLEW2QBd6WFTppDjAwH",
    "PN5rIGT2WHTBQxER0ufgt",
    "4hhEX3j7hS0fVOdupEO4WJ",
    "hUAIYHpiNYkZaDYma0VZ0",
    "X5e17dI4XUnxd0yhiwJo1",
    "5mA2jaOzWCcjeBmLVyoZDi"
  ])
};

export default HIDDEN_FAQ_IDS_BY_CATEGORY;
